import React, { useState, useEffect } from "react";
import ProjectModuleApi from "../../api/ProjectModule";
import { showError, showSuccess } from "../../utils/toastUtils";

function EditDetails({ data, fetchModuleData }) {
  const [formData, setFormData] = useState({ module_name: "", estimated_hours: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setFormData({ module_name: data.module_name, estimated_hours: data.estimated_hours });
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await ProjectModuleApi.update({ id: data._id, ...formData });
      if (res.code === 200) {
        showSuccess(res.message);
        fetchModuleData();
        document.getElementById("closeEditOffcanvas").click();
      }
    } catch (err) {
      showError("Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Edit Module</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="closeEditOffcanvas" />
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Module Name</label>
            <input
              type="text"
              className="form-control"
              value={formData.module_name}
              onChange={(e) => setFormData({ ...formData, module_name: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Estimated Hours</label>
            <input
              type="number"
              className="form-control"
              value={formData.estimated_hours}
              onChange={(e) => setFormData({ ...formData, estimated_hours: e.target.value })}
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Updating..." : "Update Module"}
          </button>
        </form>
      </div>
    </>
  );
}

export default EditDetails;